<script setup lang="ts">
import userStore from '@/store/UserStore.ts'
</script>

<template>
  <svg
    width="40" height="40" viewBox="0 0 40 40" fill="none"
    xmlns="http://www.w3.org/2000/svg"
    :class="{
      'brand-va': userStore.brand === 'VAILLANT',
      'brand-sd': userStore.brand === 'SDBG'
    }">
    <path
      id="Line-2"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M31.977 8.33301H23.4197C22.9471 8.33301 22.5641 8.7161 22.5641 9.18866V11.327H20.8542V9.18866C20.8542 8.7161 20.4712 8.33301 19.9986 8.33301H8.02167C7.54911 8.33301 7.16602 8.7161 7.16602 9.18866V15.1775C7.16602 15.6501 7.54911 16.0332 8.02167 16.0332H13.1526V17.7437H8.02167C7.54911 17.7437 7.16602 18.1268 7.16602 18.5994V30.577C7.16602 31.0496 7.54911 31.4327 8.02167 31.4327H19.9993C20.4716 31.4323 20.8542 31.0493 20.8542 30.577V25.4461H22.5648V30.577C22.5648 31.0493 22.9474 31.4323 23.4197 31.4327H31.977C32.4496 31.4327 32.8327 31.0496 32.8327 30.577V9.18866C32.8327 8.7161 32.4496 8.33301 31.977 8.33301ZM8.87733 10.0443H19.1437V14.3218H8.87733V10.0443ZM19.1437 29.7252H8.87733V19.455H19.1437V29.7252ZM20.8543 23.7326V18.6016C20.8543 18.1291 20.4712 17.746 19.9986 17.746H14.8677V16.0332H19.9986C20.4712 16.0332 20.8543 15.6501 20.8543 15.1775V13.0384H22.5648V23.7326H20.8543ZM31.1214 29.7252H24.2769V10.0443H31.1214V29.7252Z"
      fill="none" />
    <mask
      id="mask0_3588_8221" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="7"
      y="8" width="26" height="24">
      <path
        id="Line-2"
        fill-rule="evenodd" clip-rule="evenodd"
        d="M31.977 8.33301H23.4197C22.9471 8.33301 22.5641 8.7161 22.5641 9.18866V11.327H20.8542V9.18866C20.8542 8.7161 20.4712 8.33301 19.9986 8.33301H8.02167C7.54911 8.33301 7.16602 8.7161 7.16602 9.18866V15.1775C7.16602 15.6501 7.54911 16.0332 8.02167 16.0332H13.1526V17.7437H8.02167C7.54911 17.7437 7.16602 18.1268 7.16602 18.5994V30.577C7.16602 31.0496 7.54911 31.4327 8.02167 31.4327H19.9993C20.4716 31.4323 20.8542 31.0493 20.8542 30.577V25.4461H22.5648V30.577C22.5648 31.0493 22.9474 31.4323 23.4197 31.4327H31.977C32.4496 31.4327 32.8327 31.0496 32.8327 30.577V9.18866C32.8327 8.7161 32.4496 8.33301 31.977 8.33301ZM8.87733 10.0443H19.1437V14.3218H8.87733V10.0443ZM19.1437 29.7252H8.87733V19.455H19.1437V29.7252ZM20.8543 23.7326V18.6016C20.8543 18.1291 20.4712 17.746 19.9986 17.746H14.8677V16.0332H19.9986C20.4712 16.0332 20.8543 15.6501 20.8543 15.1775V13.0384H22.5648V23.7326H20.8543ZM31.1214 29.7252H24.2769V10.0443H31.1214V29.7252Z"
        fill="none" />
    </mask>
    <g mask="url(#mask0_3588_8221)" />
  </svg>
</template>
<style lang="scss" scoped>
#Line-2 {
  .brand-va & {
    fill: #00917E;
  }

  .brand-sd & {
    fill: #CC0033;
  }
}
</style>
